export default {
  SET_USERS: (state, users) => (state.users = users),
  SET_USER_ITEM: (state, user) => (state.user = user),
  SET_USER(state, user) {
    state.users.splice(
      state.users.findIndex((s) => s.uid == user.uid),
      1,
      user
    );
  },
};
